import { isServerSide } from "utils/general";
const Sentry = require("@sentry/nextjs");
const GLOVE_TEST_PREFIX = "glove_test_";
const isGloveTest = (test)=>test.name.startsWith(GLOVE_TEST_PREFIX);
const getGloveTests = (abTests = [])=>abTests.filter((test)=>isGloveTest(test));
const saveActiveGloveTestsToWindow = (abTests = [])=>{
    if (isServerSide()) return;
    window.activeGloveTests = getGloveTests(abTests);
};
export default saveActiveGloveTestsToWindow;
